<template>
  <div class="m-4">
    <div class="breadcrumb">
      <h4 class="overview-text breadcrumb-first">
        <router-link :to="{ name: 'awsoverview' }" class="breadcrumb-link">
          {{ $t('aws.overviewText') }}
        </router-link>
      </h4>
      <h4 class="overview-text breadcrumb-first">
        <router-link
          :to="{
            path: `/cloud/aws/rds/${breadcrumbData[1]}/${breadcrumbData[2]}`,
          }"
          class="breadcrumb-link"
        >
          {{ breadcrumbData[1] }} >
        </router-link>
      </h4>
      <h4 class="overview-text">
        {{ breadcrumbData[3] }}
      </h4>
    </div>
    <!-- <h4 class="performance-metrics-text">
      {{ $t('aws.performanceMetrics') }}
    </h4> -->
    <div class="database-graphs">
      <RexCollapse
        bordered="false"
        ghost="true"
        v-model:activeKey="activeKey"
        expandIconPosition="end"
      >
        <RexCollapsePanel key="1" style="text-align: start">
          <template #header>
            <span
              style="
                font-family: RakutenSansUI-Bold !important;
                font-size: 1.5rem;
              "
            >
              {{ $t('aws.performanceMetrics') }}
            </span>
          </template>
          <div class="first-set">
            <div
              class="chart-element"
              v-for="(chartConfig, index) in getTemplate"
              :key="index"
              :style="{ width: chartConfig.width }"
            >
              <GraphBuilder
                :chartConfig="chartConfig"
                :index="index"
                :layoutIndex="0"
              />
            </div>
          </div>

          <!-- <h4 class="performance-metrics-text">
        {{ $t('aws.readReplicaMetrics') }}
      </h4> -->
        </RexCollapsePanel>
        <RexCollapsePanel key="2" style="text-align: start">
          <template #header>
            <span
              style="
                font-family: RakutenSansUI-Bold !important;
                font-size: 1.5rem;
              "
            >
              {{ $t('aws.readReplicaMetrics') }}
            </span>
          </template>
          <div class="second-set">
            <div
              class="chart-element"
              v-for="(chartConfig, index) in filteredReadReplicaCharts"
              :key="index"
              :style="{ width: chartConfig.width }"
            >
              <GraphBuilder
                :chartConfig="chartConfig"
                :index="
                  index +
                  (awsTemplates.RDS.databases?.graphs.template.length - 2)
                "
                :layoutIndex="0"
              />
            </div>
          </div>
        </RexCollapsePanel>
      </RexCollapse>
    </div>
  </div>
</template>
<script>
import awsTemplates from '@/utils/templates/cloud.aws.charts.template.js';
import GraphBuilder from '@/components/Common/GraphBuilder.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { ref } from 'vue';
import RexCollapse from '@/rex-components/RexCollapse.vue';
import RexCollapsePanel from '@/rex-components/RexCollapsePanel.vue';
import rdsMySqlCharts from '@/utils/templates/cloudTemplates/aws/rds.mysql.config.js';

const activeKey = ref(['1', '2']);
export default {
  components: {
    GraphBuilder,
    RexCollapse,
    RexCollapsePanel,
  },
  name: 'DatabasesPage',
  data() {
    return {
      awsTemplates: awsTemplates,
      activeKey: ['1', '2'],
    };
  },
  mounted() {
    this.setCurrentPage('databases');
    this.activeKey = ['1', '2'];
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    ...mapGetters('cloudState/detail', ['getAwsServices']),
    ...mapState('cloudState/detail', ['currentSubType']),
    breadcrumbData() {
      return this.$route.params.databaseId.split('/');
    },
    getTemplate() {
      const charts = rdsMySqlCharts().lineChartsDatabasePage.slice(0, -2);

      return charts?.filter((chartConfig) => {
        if (this.currentDatabaseType === 'mssql') {
          return !['Swap usage'].includes(chartConfig.header.title);
        }
        return true;
      });
    },
    currentDatabaseType() {
      // Assuming you have a mapState variable named currentSubType
      return this.currentSubType.toLowerCase().split('_')[1];
    },
    filteredReadReplicaCharts() {
      // Get the last two charts from the template
      const charts = rdsMySqlCharts().lineChartsDatabasePage.slice(-2);

      return charts?.filter((chartConfig) => {
        if (
          this.currentDatabaseType === 'mssql' ||
          this.currentDatabaseType === 'postgres'
        ) {
          return !['Bin log disk usage'].includes(chartConfig.header.title);
        }
        return true;
      });
    },
  },
  methods: {
    ...mapMutations('cloudState/detail', ['setCurrentPage']),
    handleSubscriptionClick() {
      this.$router.push({
        name: 'subscriptionId',
        params: this.breadcrumbData[0],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb-text {
  display: flex;
  margin-bottom: 1.25rem;
  color: $color-brand-accent;
}

.first-set {
  @include flex-center-justify(start);
  flex-wrap: wrap;
  gap: 1.25rem;
}

.second-set {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.25rem;
}

.performance-metrics-text {
  display: flex;
  margin-bottom: 1.25rem;
  margin-top: 1.25rem;
  color: white;
}

.breadcrumb {
  display: flex;
  background: inherit;
  gap: 0.3125rem;
}

.breadcrumb-first {
  cursor: pointer;
}

.breadcrumb-link:hover {
  text-decoration: none;
  color: inherit;
  color: $color-brand-accent;
}

.breadcrumb-link {
  color: $color-brand-accent;
  text-decoration: none;
}

.ant-collapse-header-text {
  font-size: 1.125rem;
  font-weight: bold;
}
</style>
